import React from 'react';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import { bem } from 'helpers/class-name';

import ManualServiceStatus from './ManualServiceStatus/ManualServiceStatus';
import ServicesListItemMetadata from './ServicesListItemMetadata';

const { element } = bem('services-list-item');

const PricingServicesListItemContent = ({
  currencyCode,
  duration,
  equipmentLength,
  hasPayout,
  isDisabled,
  name,
  payoutRate,
  practitionersLength,
  service,
}) => (
  <div className={element('row')}>
    <div className={element('name-col')}>
      <ServicesListItemMetadata
        duration={duration}
        equipmentLength={equipmentLength}
        isDisabled={isDisabled}
        name={name}
        practitionersLength={practitionersLength}
      />
    </div>
    <div className={element('payout-col')}>
      {hasPayout ? <Message format="currency" currency={currencyCode} value={payoutRate} /> : '––'}
    </div>
    <div className={element('status-col')}>
      <ManualServiceStatus service={service} />
    </div>
  </div>
);

PricingServicesListItemContent.propTypes = {
  currencyCode: PropTypes.string,
  duration: PropTypes.string,
  equipmentLength: PropTypes.number,
  hasPayout: PropTypes.bool,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  payoutRate: PropTypes.number,
  practitionersLength: PropTypes.number,
  service: PropTypes.shape({
    id: PropTypes.number,
    disabled: PropTypes.bool,
    price: PropTypes.number,
    status: PropTypes.string,
    payout: PropTypes.shape({}),
    retailRateRequest: PropTypes.shape({}),
    classPricingRule: PropTypes.shape({}),
  }),
};

export default PricingServicesListItemContent;
